import ScrollToTop from 'components/app/modules/scrollToTop/ScrollToTop';
import AppBar from 'components/common/controls/navbar/AppBar';
import ModalContainer from 'components/modal/ModalContainer';
import { FontSizes } from 'lib/styles/Typography';
import LandingPage from 'pages/Landing.page';
// import SellingTickets from 'pages/SellingTickets';
import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import Helmet from 'react-helmet';
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router';
import { Elements } from 'react-stripe-elements';
import { history, store } from 'stores/store.js';
import styled from 'styled-components';
import './app.css';

// import Pricing from 'pages/Pricing';

const AppDiv = styled.div`
	font-size: ${FontSizes.normal};
	min-height: 100vh !important;
`;

/**
 * Main routing component.
 */
class App extends Component<{ [label: string]: any }> {

	constructor(props) {
		super(props);
	}

	public render() {
		return (
			<Router history={history} >
				<Provider store={store}>
					<Elements>
						<AppDiv className='app zoomOut'>
							{/* html metadata */}
							<Helmet
								title={'Event Ticketing'}
								meta={[
									{ name: 'author', content: "ISOTOPE TICKETING" },
									{ name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=yes' },
									{ property: 'og:title', content: 'ISOTOPE Ticketing' },
									{ property: 'og:site_name', content: "ISOTOPE" },
									{ property: 'og:image', content: "https://www.isotopeticketing.com/images/og-image.jpg" },
									{ property: 'og:site_name', content: "ISOTOPE" },
									{ property: 'og:image:width', content: '1428' },
									{ property: 'og:image:height', content: '748' },
									{ property: 'theme-color', content: '#000000' },
									{ property: 'charset', content: 'utf-8' },
									{ property: "google-site-verification", content: "zGFGX-x2yPoIdPnYyLJSxqwLu1gDg_OcKKahDfBpqMY" },
									{ property: "og:image:secure_url", content: "https://www.isotopeticketing.com/images/og-image.jpg" },
									{ property: 'description', content: 'Isotope Ticketing & Event Management Platform' },
								]}
							/>

							{/* Modal */}
							<ModalContainer />

							<div className='stick'>
								<AppBar />
							</div>
							<div className='mainpage'>
								{/* All routes */}
								<ScrollToTop>
									<Switch>
										<Route exact={true} path='/' component={LandingPage} />
									</Switch>
								</ScrollToTop>
							</div>

						</AppDiv>
					</Elements>
				</Provider>
			</Router >
		);
	}
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/components/app/App.tsx